import { render } from "./StepGettone.vue?vue&type=template&id=04af876c&scoped=true"
import script from "./StepGettone.vue?vue&type=script&lang=js"
export * from "./StepGettone.vue?vue&type=script&lang=js"

import "./StepGettone.vue?vue&type=style&index=0&id=04af876c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04af876c"]])

export default __exports__